@for (message of messages(); track message.id) {
  <div
    class="message-ui"
    [class.info]="message.level === EMessageLevel.INFO"
    [class.error]="message.level === EMessageLevel.ERROR"
    [class.warning]="message.level === EMessageLevel.WARNING"
    animate.enter="expand-down"
    animate.leave="collapse-up"
  >
    @if (message.durationMs > 0) {
      <ion-button
        aria-label="Cerrar"
        size="small"
        fill="clear"
        color="dark"
        (click)="removeMessage(message.id)"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    }
    @for (messageLine of message.message; track $index) {
      <p>{{ messageLine }}</p>
    }
  </div>
}
